<template>
    <form @submit.prevent="store" class="settings-block">
        <div class="block-header">
            <h3>{{ $t('Региональные данные') }}</h3>
        </div>
        <div class="block-content">
            <div class="form-group">
                <label for="">{{ $t('Страна') }}:</label>
                
                <multiselect 
                    v-model="form.country" 
                    :options="countries" 
                    :allow-empty="false" 
                    :searchable="false" 
                    label="name" 
                    track-by="code"
                    :show-labels="false"
                    :class="{'form-control': true, 'is-invalid': hasError('country')}">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.icon }} {{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Страна') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('country')">{{ getError('country') }}</span>
        
            <div class="form-group">
                <label for="">{{ $t('Язык') }}:</label>
                
                <multiselect 
                    v-model="form.language" 
                    :options="languages" 
                    :allow-empty="false" 
                    :searchable="false" 
                    label="name" 
                    track-by="code"
                    :show-labels="false" 
                    :class="{'form-control': true, 'is-invalid': hasError('language')}">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Язык') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('language')">{{ getError('language') }}</span>

            <div class="form-group">
                <label for="">{{ $t('Основная валюта') }}:</label>
                
                <multiselect 
                    v-model="form.currency" 
                    :options="currencies" 
                    :allow-empty="false" 
                    :searchable="true" 
                    label="name" 
                    track-by="id"
                    :show-labels="false"
                    :class="{'form-control': true, 'is-invalid': hasError('currency')}">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Основная валюта') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('currency')">{{ getError('currency') }}</span>

            <div class="btn-group">
                <button type="submit" class="btn btn-blue">{{ $t('Сохранить') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../../event-bus';

export default {
    name: "RegionalData",

    data: function() {
        return {
            form: {
                country: null,
                language: null,
                currency: null,
            },

            countries: [
                {code: 'ua', name: this.$t('Украина'), icon: "🇺🇦"},
            ],

            languages: [
                {code: 'uk', name: 'Українська'},
                {code: 'ru', name: 'Русский'},
                {code: 'en', name: 'English'},
            ],

            errors: {},
        };
    },

    watch: {
        "form.country": function() {
            delete this.errors['country'];
        },
        "form.language": function() {
            delete this.errors['language'];
        },
        "form.currency": function() {
            delete this.errors['currency'];
        },
        "user": function() {
            this.initData();
        },
    },

    mounted() {
        this.initData();
    },

    computed: {
        ...mapState(['user']),
        ...mapGetters(['currencies', 'currency']),
    },

    methods: {
        ...mapActions(['loadUserData']),

        initData() {
            this.form.country = this.countries.filter((country) => country.code == this.user.regional.country)[0];
            this.form.language = this.languages.filter((language) => language.code == this.user.regional.language)[0];
            this.form.currency = this.currency;
        },

        store() {
            axios.post('/settings/regional', this.form)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message ? data.message : $t('Настройки сохранены'), 'success');

                    this.$ga.event("regionalData", "changed");

                    this.loadUserData((user) => {
                        this.changeLanguage(this.form.language.code);
                    });
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },

		changeLanguage(lang) {
            if(lang === this.$i18n.locale) {
                return;
            }

            this.$ga.set({language: lang});
            this.$ga.event("languageChange", "changed", lang);
            
			this.$store.commit('changeLang', lang);
			this.$i18n.locale = lang;
            this.$i18n.setLocaleMessage(lang, this.translations);
            setI18NLanguage();
		},
    },
}
</script>